/* fourpaw-standard: lifecycle-delegated */
(() => {
  if (window.SafeWalkV6RealGiftRecoveryVisibility) return;

  const root = document.documentElement;
  const invalidSelector = '[data-safewalk-gift-contract="invalid"]';
  const graceMs = 1200;
  let revealTimer = 0;
  let observer = null;

  const lifecycleState = () => root.dataset.safewalkGiftReconcile || '';
  const purchasePending = () => Boolean(document.querySelector('[data-kaching-cart-status="pending"]'));
  const reconciliationPending = () => lifecycleState() === 'pending' || purchasePending();
  const hasInvalidContract = () => Boolean(document.querySelector(invalidSelector));
  const cancelReveal = () => {
    if (!revealTimer) return;
    window.clearTimeout(revealTimer);
    revealTimer = 0;
  };
  const hideRecovery = () => {
    delete root.dataset.safewalkGiftRecoveryVisible;
  };
  const revealRecovery = () => {
    if (reconciliationPending() || !hasInvalidContract()) return;
    root.dataset.safewalkGiftRecoveryVisible = 'true';
  };
  const sync = () => {
    root.dataset.safewalkGiftRecoveryGate = 'ready';
    if (reconciliationPending() || !hasInvalidContract()) {
      cancelReveal();
      hideRecovery();
      return;
    }
    if (root.dataset.safewalkGiftRecoveryVisible === 'true' || revealTimer) return;
    revealTimer = window.setTimeout(() => {
      revealTimer = 0;
      revealRecovery();
    }, graceMs);
  };
  const boot = () => {
    root.dataset.safewalkGiftRecoveryGate = 'ready';
    observer = new MutationObserver(sync);
    observer.observe(document.body, { childList: true, subtree: true });
    sync();
  };

  document.addEventListener('safewalk:real-gifts-state', sync);
  document.addEventListener('safewalk:real-gifts-rendered', sync);
  window.addEventListener('pagehide', cancelReveal, { once: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.SafeWalkV6RealGiftRecoveryVisibility = Object.freeze({
    graceMs,
    sync
  });
})();
